import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { motion } from 'framer-motion';
import { Anchor, Sun, Coffee, Waves } from 'lucide-react';
export function BluOceanSection() {
  const {
    t
  } = useLanguage();
  const icons = [Anchor, Sun, Coffee, Waves];
  return <section id="boat" className="relative py-32 overflow-hidden" data-id="element-15">
      {/* Background Image */}
      <div className="absolute inset-0" data-id="element-16">
        <img src="https://cdn.magicpatterns.com/uploads/6D87V7Nvf1t6ntM6riPJ6D/DSC01412.jpg" alt="Group of friends enjoying a private Blu Ocean boat tour" className="w-full h-full object-cover object-center" data-id="element-17" />
        <div className="absolute inset-0 bg-gradient-to-l from-ocean-dark/90 via-ocean-dark/70 to-transparent" data-id="element-18" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-end" data-id="element-19">
        <div className="max-w-2xl text-white text-right" data-id="element-20">
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="flex justify-end mb-6" data-id="element-21">
            <img src="https://cdn.magicpatterns.com/uploads/aifgHKgDB7GaFaemiHaRod/LOGO_PNG_ORIGI.png" alt="Blu Ocean Tours" className="h-28 md:h-36 w-auto object-contain drop-shadow-[0_8px_30px_rgba(0,180,216,0.35)]" data-id="element-22" />
          </motion.div>
          <motion.p initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-sand-light/90 mb-12 leading-relaxed ml-auto" data-id="element-23">
            {t.bluOceanSection.description}
          </motion.p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-12 text-left" data-id="element-24">
            {t.bluOceanSection.features.map((feature, idx) => {
            const Icon = icons[idx];
            return <motion.div key={idx} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.2 + idx * 0.1
            }} className="glass-panel p-6 rounded-2xl" data-id="element-25">
                  <Icon className="w-8 h-8 text-turquoise mb-4" data-id="element-26" />
                  <h4 className="font-bold text-xl mb-2" data-id="element-27">{feature.title}</h4>
                  <p className="text-sm text-sand-light/80" data-id="element-28">{feature.desc}</p>
                </motion.div>;
          })}
          </div>

          <motion.a initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} href="https://wa.link/qca29f" target="_blank" rel="noreferrer" className="inline-block bg-turquoise hover:bg-turquoise-light text-white font-bold px-8 py-4 rounded-full transition-colors shadow-xl" data-id="element-29">
            {t.bluOceanSection.cta}
          </motion.a>
        </div>
      </div>
    </section>;
}